import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DataEntryVehicleStepProps, FormikStep } from "src/types";

export const useDataEntryVehicleStep = ({
  step,
}: DataEntryVehicleStepProps) => {
  const { t } = useTranslation();

  const vehicleStepTitle = useMemo(() => {
    let vehicle = "";

    switch (step) {
      case FormikStep.VEHICLE_A:
        vehicle = "A";
        break;
      case FormikStep.VEHICLE_B:
        vehicle = "B";
        break;
      default:
        vehicle = "";
        break;
    }

    return `${t("commons.vehicle")} ${vehicle}`;
  }, [step, t]);

  const formikFieldBaseNameForSections = useMemo(() => {
    switch (step) {
      case FormikStep.VEHICLE_A:
        return "vehicleA";
      case FormikStep.VEHICLE_B:
        return "vehicleB";
      default:
        return "";
    }
  }, [step]);

  const subject = useMemo(() => {
    switch (step) {
      case FormikStep.VEHICLE_A:
        return t("commons.itas_insured");
      case FormikStep.VEHICLE_B:
        return t("commons.counterpart");
      default:
        return "";
    }
  }, [step, t]);

  return { vehicleStepTitle, formikFieldBaseNameForSections, subject, t };
};
